import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "item news" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["srcset"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  src: "/assets/images/Placeholder.png"
}
const _hoisted_11 = { class: "text" }
const _hoisted_12 = {
  key: 0,
  class: "tag"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 1,
  class: "date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.result?.images?.previewImage)
        ? (_openBlock(), _createElementBlock("picture", _hoisted_3, [
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(255, 235),
              media: "(min-width: 1420px)"
            }, null, 8, _hoisted_4),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(260, 240),
              media: "(min-width: 1050px)"
            }, null, 8, _hoisted_5),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(270, 250),
              media: "(min-width: 768px)"
            }, null, 8, _hoisted_6),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(335, 300),
              media: "(min-width: 450px)"
            }, null, 8, _hoisted_7),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(190, 190),
              media: "(min-width: 0px)"
            }, null, 8, _hoisted_8),
            _createElementVNode("img", {
              src: _ctx.result?.images?.previewImage?.url.toCropUrl(255, 235),
              alt: _ctx.result?.images?.previewImage?.altText
            }, null, 8, _hoisted_9)
          ]))
        : (_openBlock(), _createElementBlock("img", _hoisted_10))
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.previewTagHeader)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.previewTagHeader), 1))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: _ctx.result.url
      }, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.result?.pageTitle), 1)
      ], 8, _hoisted_13),
      (_ctx.dateString)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.dateString), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}